module.exports = __webpack_public_path__ + "static/media/tand-min.f84d80c7.png";